module.exports = __webpack_public_path__ + "static/image4-fb7980d99a9b9ed3a4cbfcfce3d38cab.jpg";